declare namespace $ {

	export class $mol_icon_vk extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=vk.view.tree.d.ts.map